import {
  CollectionLockup,
  CollectionLockupContent,
  CollectionLockupTitle,
} from "@opensea/app-kit"
import {
  Item,
  ItemAvatar,
  ItemContent,
  ItemTitle,
  TableCell,
  TableRow,
  tableRowSizeVariants,
  useTable,
} from "@opensea/ui-kit"
import type { FragmentOf } from "gql.tada"
import { readFragment } from "gql.tada"
import { TRANSFER_FLOW_FORM_ITEM_CLASSNAMES } from "../TransferFlowFormItem/constants"
import { TransferFlowReviewItemFragment } from "./TransferFlowReviewItem.fragment"

type Props = {
  item: FragmentOf<typeof TransferFlowReviewItemFragment>
}
export const TransferFlowReviewItem = ({ item: itemKey }: Props) => {
  const item = readFragment(TransferFlowReviewItemFragment, itemKey)
  const { size } = useTable()
  const { image } = tableRowSizeVariants({ size })

  return (
    <TableRow>
      <TableCell className={TRANSFER_FLOW_FORM_ITEM_CLASSNAMES.item}>
        <Item variant="unstyled">
          <ItemAvatar className={image()} src={item.imageUrl} />
          <ItemContent>
            <ItemTitle>{item.name}</ItemTitle>
            {item.collection ? (
              <CollectionLockup collection={item.collection} size="xs">
                <CollectionLockupContent>
                  <CollectionLockupTitle />
                </CollectionLockupContent>
              </CollectionLockup>
            ) : null}
          </ItemContent>
        </Item>
      </TableCell>
    </TableRow>
  )
}
